<mat-nav-list [class]="themeCss">
  <ul id="first">
    @for (item of list; track item) {
      <li mat-list-item>
        @if (!item.removed) {
          <ng-container
            [ngTemplateOutlet]="menuItem"
            [ngTemplateOutletContext]="{ item: item, level: 1 }"
          ></ng-container>
        }
      </li>
    }
  </ul>
</mat-nav-list>

<ng-template #menuItem let-item="item" let-level="level">
  <!-- link -->
  <a
    class="item-menu"
    [routerLink]="item.link !== 'logout' ? item.link : null"
    [routerLinkActive]="['is-active']"
    (click)="onItemClick(item)"
    [class.show]="item.show"
    [class.hide]="!item.show"
    [class]="'level-' + level"
    [class.collapsed]="item.collapse"
    appTooltip="{{ 'MenuTooltips.' + item.id | translate }}"
  >
    <mat-icon
      color="primary"
      [matBadge]="item.chip"
      [appTooltip]="item.chipText"
      [matBadgePosition]="'above after'"
      matBadgeColor="warn"
      [matBadgeSize]="'small'"
      >{{ item.icon }}</mat-icon
    >
    <span class="main-menu-item-text">{{ item.title }}</span>
    @if (item.id === PROFILE_ID && hasWalletBalance) {
      <span class="wallet-pill" appTooltip="Ma cagnotte de parrainage" data-cy="menu-wallet-pill">
        <mat-icon class="wallet-pill-icon">redeem</mat-icon>
        {{ wallet.balance | currency: wallet.currency : 'symbol' : '1.0-2' : 'fr' }}
      </span>
    }
    @if (item.showIconCollapse) {
      <mat-icon class="btn-collapse" (click)="toggleCollapse($event, item)">chevron_right</mat-icon>
    }
  </a>
  <!-- submenu -->
  @if (item.childs) {
    <ul class="wrap-level-{{ level + 1 }}">
      @for (subItem of item.childs; track subItem) {
        <li>
          @if (!subItem.removed) {
            <ng-container
              [ngTemplateOutlet]="menuItem"
              [ngTemplateOutletContext]="{ item: subItem, level: level + 1 }"
            ></ng-container>
          }
        </li>
      }
    </ul>
  }
</ng-template>
